export enum FieldType {
  text = 'text',
  number = 'number',
  email = 'email',
  url = 'url',
  tel = 'tel',
  date = 'date',
  select = 'select',
  multiSelect = 'multi-select',
}
